
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import type { JSX } from "react";
import LoadingSplash from "@/components/LoadingSplash";

// export const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
//   const { user, loading } = useAuth();

//   if (loading) return <div>Loading...</div>;

//   if (!user) return <Navigate to="/login" replace />;

//   return children;
// };


export const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const { user, loading } = useAuth();

  // console.log("ProtectedRoute:", { loading, user });

  if (loading) return <LoadingSplash />;

  if (!user) return <Navigate to="/login" replace />;

  return children;
};

